import { render } from "./PositionsList.vue?vue&type=template&id=404a2151"
import script from "./PositionsList.vue?vue&type=script&lang=js"
export * from "./PositionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__